export const passwordResetStepper = [
  'メールアドレス',
  'セキュリティコード確認',
  '新しいパスワード作成',
  '完了',
]
